import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { CategoryRequest, CategoryResponse } from '@/types/product';

export const categoriesApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<CategoryResponse>>>('/v1/categories', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<CategoryResponse>>(`/v1/categories/${id}`)),

  create: (body: CategoryRequest) =>
    unwrap(api.post<ApiResponse<CategoryResponse>>('/v1/categories', body)),

  update: (id: number, body: CategoryRequest) =>
    unwrap(api.put<ApiResponse<CategoryResponse>>(`/v1/categories/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/categories/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<CategoryResponse>>(`/v1/categories/${id}/activate`, null, {
        params: { active },
      }),
    ),
};
